import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { useMemo } from 'react'

import { SessionProvider } from '@/shared/auth/session'
import { FeaturesProvider } from '@/shared/features/features'
import { DirectionProvider } from '@/shared/i18n/DirectionProvider'

export function Providers({ children }: { children: React.ReactNode }) {
  const queryClient = useMemo(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 30_000,
            retry: 2,
            refetchOnWindowFocus: false,
          },
        },
      }),
    [],
  )

  return (
    <QueryClientProvider client={queryClient}>
      <SessionProvider>
        <FeaturesProvider>
          <DirectionProvider>{children}</DirectionProvider>
        </FeaturesProvider>
      </SessionProvider>
    </QueryClientProvider>
  )
}
